import React from 'react'
import { Box, borderRadius, color, shadow, spacer, padding } from 'stylist'
import styled from 'react-emotion'
import ClipDurationBar from './ClipDurationBar'
import ClipFeedback from './ClipFeedback'
import { formatTime } from 'utils/time'

const ClipTitle = styled.div`
  font-weight: 700;
  color: ${({ dark }) => (dark ? color('white') : color('ink'))};
  padding-bottom: 10px;
  display: inline-flex;
`

const ClipDuration = styled.div`
  float: right;
  color: ${({ dark }) => (dark ? color('white') : color('cadet'))};
`

const BoxCardItem = styled(Box.Item)`
  ${borderRadius('default')};
  ${shadow('close')};
  margin: 0 0 ${spacer(3)};
  cursor: pointer;
  display: flex;
  opacity: ${({ muted }) => (muted ? 0.4 : 1)};
  background-color: ${({ dark }) => (dark ? color('ink') : color('white'))};
`

const ClipCardContentSection = styled.div`
  flex-grow: 1;
  ${padding('sm')};

  border-right: 1px solid ${color('paleGrey')};
`

const ClipCard = ({ clip, title, duration, dark, ...props }) => (
  <BoxCardItem
    muted={clip.feedback && !clip.feedback.positive}
    key={clip.id}
    dark={dark}
    {...props}
  >
    <ClipCardContentSection dark={dark}>
      <ClipTitle dark={dark}>{title}</ClipTitle>
      <ClipDuration dark={dark}>
        {formatTime(clip.endTime - clip.startTime)}
      </ClipDuration>
      <ClipDurationBar clip={clip} duration={duration} />
    </ClipCardContentSection>
    <ClipFeedback clip={clip} dark={dark} />
  </BoxCardItem>
)

export default ClipCard



// WEBPACK FOOTER //
// ./src/routes/video/components/ClipCard.js